/**
 * Formats a number as a US dollar amount
 * @param amount - The number to format as dollars
 * @returns A string representing the amount in US dollars (e.g. "$1,234.56")
 * @throws Error if amount is not a number
 */
export const formatDollars = (amount: number, precision = 2): string => {

	amount = typeof amount === "number" ? amount : 0;
	if(typeof amount !== "number") {
		throw new Error("formatDollars: Amount must be a number");
	}

	if(amount >= 100_000)
		precision = 0;

	amount = amount * (10**precision) < 0 && amount * (10**precision) > -1 ? 0 : amount;

	return amount.toLocaleString("en-US", {
		style: "currency",
		currency: "USD",
		minimumFractionDigits: precision,
		maximumFractionDigits: precision,
	});

};
